import ProjectCard from '../components/ProjectCard';
import React, {Component} from 'react';
import NavBar from '../components/navbar';
import { Row, Col } from 'react-bootstrap';
import CustomBtn from '../components/CustomBtn';
import CompanyCard from '../components/CompanyCard';
import { withStyles } from '@material-ui/core/styles';

// import SideBar from '../components/Sidebar';
const useStyles= theme =>({
    root:{
      '& .MuiSvgIcon-root':{
        color:'#153BAB',
      },
      sideContainer:{
        display:'flex',
    
    
      },
      iconBtn:{
        '& .MuiSvgIcon-root':{
          color:'#153BAB',
        },
        marginLeft:'100px',
        marginTop:'10px'
      },
    },})
class BusinessProjectsList extends Component{
render()
{
    const {classes} = this.props;
    return(
        <div className={classes.root}>
      <NavBar type='main'/>
      <div>
            <Row> 
            </Row>
            <Row>
            <Col xs={4} md={4}>
                </Col>
            <Col xs={12} md={12}>
    {/*company card should be wider, did not know if I could create a new component or change in the width*/}
            <CompanyCard></CompanyCard>
                </Col>  
                <Col xs={4} md={4}>
            </Col>  
            </Row>
            
            <Row>
            <Col xs={4} md={4}>
                <ProjectCard></ProjectCard>
                <CustomBtn className={classes.iconBtn} txt={"Details"}></CustomBtn>
                </Col>        
            <Col xs={4} md={4}>
            <ProjectCard></ProjectCard>
            <CustomBtn className={classes.iconBtn} txt={"Details"}></CustomBtn>
            </Col>
            <Col xs={4} md={4}>
            <ProjectCard></ProjectCard>
            <CustomBtn className={classes.iconBtn} txt={"Details"}></CustomBtn>
            </Col>  
            </Row>
            </div>
        </div>
    )
}
}
export default withStyles(useStyles)(BusinessProjectsList);
  